// Only works for string enums
// Number enums got reverse mapping so it's more complicated
export function isEnum<T extends Record<string, string>>(value: unknown, enumObj: T): value is T[keyof T] {
    return Object.values(enumObj).includes(value as T[keyof T]);
}
